import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { errMsg } from "../lib/api";
import { useI18n } from "../lib/i18n";
import { useAuth } from "../lib/auth";
import { useStore } from "../lib/store";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { ShieldCheck } from "lucide-react";

export default function Login() {
  const { t } = useI18n();
  const { login, logout } = useAuth();
  const { storeName } = useStore();
  const navigate = useNavigate();
  const [form, setForm] = useState({ email: "", password: "" });
  const [busy, setBusy] = useState(false);

  const submit = async () => {
    setBusy(true);
    try {
      const u = await login(form.email.trim(), form.password);
      if (!["owner", "cashier"].includes(u.role)) {
        logout();
        toast.error(t("owner_only"));
        return;
      }
      toast.success(`${t("login_ok")} ${u.name}`);
      navigate("/kasir");
    } catch (e) {
      toast.error(errMsg(e, "Gagal masuk"));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen bg-gray-950 flex items-center justify-center px-5 overflow-x-hidden">
      <div className="w-full max-w-sm space-y-6" data-testid="owner-login-page">
        <div className="space-y-2">
          <img
            src="/logo.png"
            alt="Kumamoto Halal Food"
            className="h-14 w-14 rounded-2xl object-cover"
            data-testid="login-logo"
          />
          <h1 className="font-display text-3xl font-semibold text-white leading-tight">
            {storeName}
          </h1>
          <p className="text-sm text-gray-400 flex items-center gap-1.5">
            <ShieldCheck size={14} /> {t("owner_login_sub")}
          </p>
        </div>
        <div className="space-y-3 bg-gray-900 border border-gray-800 rounded-2xl p-5">
          <Input
            data-testid="owner-email-input"
            type="email"
            placeholder={t("email")}
            className="bg-gray-950 border-gray-800 text-white placeholder:text-gray-500"
            value={form.email}
            onChange={(e) => setForm({ ...form, email: e.target.value })}
          />
          <Input
            data-testid="owner-password-input"
            type="password"
            placeholder={t("password")}
            className="bg-gray-950 border-gray-800 text-white placeholder:text-gray-500"
            value={form.password}
            onChange={(e) => setForm({ ...form, password: e.target.value })}
            onKeyDown={(e) => e.key === "Enter" && submit()}
          />
          <Button
            className="w-full h-11"
            data-testid="owner-login-btn"
            disabled={busy || !form.email.trim() || !form.password}
            onClick={submit}
          >
            {t("login")}
          </Button>
        </div>
        <button
          data-testid="goto-storefront-btn"
          onClick={() => navigate("/toko")}
          className="w-full text-sm text-gray-400 hover:text-white transition-colors duration-200"
        >
          {t("go_store")}
        </button>
      </div>
    </div>
  );
}
